import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import SideNav from "./SideNav";
import { fetchProfile } from "../../services/api";

/**
 * MeetDigisGallery – vertically scrolling image showcase.
 * Hover to slightly zoom; click to view full size in a modal.
 * Shows the logged‑in username in the sticky sidebar (same as Profile page).
 */
const MeetDigisGallery = () => {
  /* ---------- state ---------- */
  const [currentIndex, setCurrentIndex] = useState(null); // null ⇒ modal closed
  const [profile, setProfile] = useState(null);

  /* ---------- misc ---------- */
  const navigate = useNavigate();
  const token = localStorage.getItem("authToken");

  /* ---------- fetch user info for sidebar ---------- */
  useEffect(() => {
    const loadProfile = async () => {
      try {
        const data = await fetchProfile(token);
        setProfile(data);
      } catch (err) {
        console.error("Error fetching profile in MeetDigisGallery:", err);
      }
    };
    loadProfile();
  }, [token]);

  // TODO: replace with real Digis images
  const images = [
    "https://res.cloudinary.com/dnbbm9vzi/image/upload/v1751719243/22ea803eea56bb36976e7b2b7a64c376_cr42lm.jpg",
    "https://res.cloudinary.com/dnbbm9vzi/image/upload/v1751719242/75b5e47ec292d7d156e925896391e2fd_dhzqwk.jpg",
    "https://res.cloudinary.com/dnbbm9vzi/image/upload/v1751719242/5945b822df53a8fb6508f0a30b305aa3_ltymlj.jpg",
    "https://res.cloudinary.com/dnbbm9vzi/image/upload/v1751719241/bf8120005f34824cc05842174f22f513_ftrni3.jpg",
    "https://res.cloudinary.com/dnbbm9vzi/image/upload/v1751719242/47b694fe7e928d356a1163e6701c12cb_wjjjr0.jpg",
    "https://res.cloudinary.com/dnbbm9vzi/image/upload/v1751722694/492de55f6eab4a84dcdc076899af3d0e_wc5nlc.jpg",
    "https://res.cloudinary.com/dnbbm9vzi/image/upload/v1751722695/754c1026fabe389a594aa5095ca99c3a_eyzc6q.jpg",
    "https://res.cloudinary.com/dnbbm9vzi/image/upload/v1751722698/f385e94d63d42023d15ae9bf5531a394_d1agv0.jpg",
    "https://res.cloudinary.com/dnbbm9vzi/image/upload/v1751722698/1eb37973345a910ebc3de49793fed61f_hifhev.jpg",
    "https://res.cloudinary.com/dnbbm9vzi/image/upload/v1751722695/116d409e936b6dd8deb0535ec9bf4be1_rqyvoa.jpg", 
    "https://res.cloudinary.com/dnbbm9vzi/image/upload/v1751722938/dcc4f4fc055d52a6f5b49f304f73b398_hts9eu.jpg",
    "https://res.cloudinary.com/dnbbm9vzi/image/upload/v1751723032/559051c719a60353d6ed8a884a774efc_wgjuqn.jpg",
    "https://res.cloudinary.com/dnbbm9vzi/image/upload/v1751723031/c0246267069ebbb4852460bb0a6f30f1_gxhifk.jpg",
    "https://res.cloudinary.com/dnbbm9vzi/image/upload/v1751795608/49852092_772025806464641_6100464825891028992_n_ejaynv.jpg",
    "https://res.cloudinary.com/dnbbm9vzi/image/upload/v1751795609/69901463_926469177686969_8156076327405879296_n_lxq2er.jpg",
    "https://res.cloudinary.com/dnbbm9vzi/image/upload/v1751795609/72840762_962373054096581_4206600654577205248_n_jadmor.jpg",
    "https://res.cloudinary.com/dnbbm9vzi/image/upload/v1751795611/69481367_926468891020331_1483457098170761216_n_zlixm7.jpg",
    "https://res.cloudinary.com/dnbbm9vzi/image/upload/v1751795610/69858988_926469161020304_5823721301117763584_n_fthh0c.jpg",
    "https://res.cloudinary.com/dnbbm9vzi/image/upload/v1751795732/49798853_776750815992140_7371767268537008128_n_jhpibg.jpg",
    "https://res.cloudinary.com/dnbbm9vzi/image/upload/v1751795734/49643221_776750982658790_92019420913729536_n_h1yrpp.jpg",
    "https://res.cloudinary.com/dnbbm9vzi/image/upload/v1751795735/54255000_818184715182083_2064172080005382144_n_j0fpcj.jpg",
    "https://res.cloudinary.com/dnbbm9vzi/image/upload/v1751795736/75594538_986068245060395_4741318190234075136_n_l8l0tl.jpg",
    "https://res.cloudinary.com/dnbbm9vzi/image/upload/v1751795737/75032051_976438989356654_5655566060099731456_n_hiva44.jpg",
    "https://res.cloudinary.com/dnbbm9vzi/image/upload/v1751795737/74537463_986068375060382_894648950546497536_n_rb3obf.jpg",
    "https://res.cloudinary.com/dnbbm9vzi/image/upload/v1751795838/245852820_1533030930364121_1466439627431019243_n_y7dtgn.jpg",
    "https://res.cloudinary.com/dnbbm9vzi/image/upload/v1751795840/84801418_1063922260608326_2023413287042940928_n_ml0nhm.jpg",
    "https://res.cloudinary.com/dnbbm9vzi/image/upload/v1751795838/485778901_1233974502065611_3900914642496352683_n_v1xtvt.jpg",
    "https://res.cloudinary.com/dnbbm9vzi/image/upload/v1751795843/471133444_2351051125228760_7881723214461162462_n_r93zla.jpg",
    "https://res.cloudinary.com/dnbbm9vzi/image/upload/v1751795845/82391318_1045919105741975_2932573063771848704_n_t2mvn0.jpg",
    "https://res.cloudinary.com/dnbbm9vzi/image/upload/v1751795844/82717423_1045919142408638_5610929882331611136_n_ghqtzj.jpg",
  ];

  /* ---------- helpers ---------- */
  const closeModal = () => setCurrentIndex(null);
  const showPrev   = () => setCurrentIndex((i) => (i > 0               ? i - 1 : i));
  const showNext   = () => setCurrentIndex((i) => (i < images.length-1 ? i + 1 : i));

  /* ---------- render ---------- */
  return (
    <div className="dashboard-background">
      <div className="container-fluid">
        <div className="row">
          {/* ---------- Sidebar ---------- */}
          <SideNav userProfile={profile} handleLogout={() => navigate("/logout")} />

          {/* ---------- Main content ---------- */}
          <main
            className="col-md-9 ms-sm-auto col-lg-10 px-4 d-flex flex-column"
            style={{ minHeight: "100vh" }}
          >
            {/* logo + heading */}
            <div className="text-center mt-3 mb-4 d-flex align-items-center justify-content-center">
              <img
                src="https://res.cloudinary.com/dnbbm9vzi/image/upload/v1747769920/logo_oq3zwy.png"
                alt="Logo"
                style={{ width: 50, height: 50, marginRight: 10 }}
              />
              <h1 className="mb-0 fw-bold">Digis Customer Portal</h1>
            </div>

            {/* meet digis intro */}
            <div className="flex-grow-1 d-flex flex-column align-items-center mt-3">
              <h2 className="fw-bold text-center">Meet Your Team</h2>
              <p className="text-center text-dark fs-5 mb-4">
                A glimpse into our culture, events and day‑to‑day life at Digis.
              </p>

              {/* ---------- gallery (vertical scroll) ---------- */}
              <div className="overflow-auto w-100" style={{ maxHeight: "70vh" }}>
                <div
                  className="d-flex flex-column align-items-center"
                  style={{ gap: "1rem" }}
                >
                  {images.map((src, idx) => (
                    <img
                      key={idx}
                      src={src}
                      alt={`Digis ${idx + 1}`}
                      className="rounded shadow-sm"
                      style={{
                        width: "100%",
                        maxWidth: 800,
                        height: "auto",
                        cursor: "pointer",
                        transition: "transform 0.3s",
                      }}
                      onMouseEnter={(e) =>
                        (e.currentTarget.style.transform = "scale(1.02)")
                      }
                      onMouseLeave={(e) =>
                        (e.currentTarget.style.transform = "scale(1)")
                      }
                      onClick={() => setCurrentIndex(idx)}
                    />
                  ))}
                </div>
              </div>
            </div>

            {/* ---------- enlarge modal ---------- */}
            {currentIndex !== null && (
              <div
                className="modal fade show"
                style={{ display: "block", backgroundColor: "rgba(0,0,0,0.7)" }}
                tabIndex={-1}
                onClick={closeModal} /* click backdrop to close */
              >
                <div
                  className="modal-dialog modal-dialog-centered modal-lg"
                  onClick={(e) => e.stopPropagation()} /* ignore clicks inside */
                >
                  <div className="modal-content border-0 bg-transparent">
                    <div className="position-relative">
                      {/* full‑size image */}
                      <img
                        src={images[currentIndex]}
                        alt=""
                        className="img-fluid rounded w-100"
                      />

                      {/* close × */}
                      <button
                        type="button"
                        className="btn btn-light btn-sm position-absolute top-0 end-0 m-2 rounded-circle"
                        aria-label="Close"
                        style={{ width: 32, height: 32, lineHeight: 1 }}
                        onClick={closeModal}
                      >
                        &times;
                      </button>

                      {/* previous arrow */}
                      <button
                        type="button"
                        className="btn btn-light position-absolute top-50 start-0 translate-middle-y ms-2"
                        style={{ width: 40, height: 40 }}
                        aria-label="Previous image"
                        onClick={(e) => {
                          e.stopPropagation();
                          showPrev();
                        }}
                        disabled={currentIndex === 0}
                      >
                        &#10094;
                      </button>

                      {/* next arrow */}
                      <button
                        type="button"
                        className="btn btn-light position-absolute top-50 end-0 translate-middle-y me-2"
                        style={{ width: 40, height: 40 }}
                        aria-label="Next image"
                        onClick={(e) => {
                          e.stopPropagation();
                          showNext();
                        }}
                        disabled={currentIndex === images.length - 1}
                      >
                        &#10095;
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </main>
        </div>
      </div>
    </div>
  );
};

export default MeetDigisGallery;
